import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import { Box, Typography } from "@material-ui/core"
import ViewerBackButtonBox from "./ViewerBackButtonBox"
import ViewerDocumentListAccordion from "./ViewerDocumentListAccordion"

import { useHistory } from "react-router-dom"
import ViewerDocumentListPagination from "./ViewerDocumentListPagination"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	root: {
		...theme.typography.body1,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
		height: "70vh",
		overflowX: "auto",
	},
	documentList: {
		height: "61vh",
		minWidth: "300px",
	},
	title: {
		padding: "12px 14px",
		width: "100%",
		backgroundColor: theme.palette.grey[50],
	},
}))

const ViewerDocumentList = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")

	return (
		<>
			<Box>
				<ViewerBackButtonBox
					loading={props?.loading}
					retainedFilterJobData={props?.retainedFilterJobData}
					prevPage="All Documents"
					prevPath={props?.prevPath}
				/>
			</Box>
			<Box className={classes.root}>
				<Typography className={classes.title}>{t("viewer.document_hits")}</Typography>
				<Box className={classes.documentList}>
					<ViewerDocumentListAccordion retainedFilterJobData={props?.retainedFilterJobData} />
				</Box>
			</Box>
			<ViewerDocumentListPagination retainedFilterJobData={props?.retainedFilterJobData} />
		</>
	)
}

export default ViewerDocumentList
